'use client';

import type { PropsWithChildren } from 'react';
import type { Collection } from '@/app/actions/collection';
import type { SportType } from '~/model/SportType';
import { useEffect } from 'react';
import { useProgressContext } from '@/app/components/Provider';
import { SportsProvider } from '@/app/components/Provider/SportsProvider';
import { useFormContext } from '../FormProvider';
import { ProfileCompletionIntroduction } from '../ProfileCompletionIntroduction/ProfileCompletionIntroduction';
import { useContributorContext } from '../provider/ContributorProvider';
import { useProfileCompletionContext } from '../provider/ProfileCompletionProvider';
import { CriteriaCompletion } from './CriteriaCompletion';

export const PendingCriteria = ({
  children,
  sports,
}: PropsWithChildren<{ sports: Collection<SportType> }>) => {
  const { contributor, getContributions } = useContributorContext();
  const { interaction } = useFormContext();
  const { setTotal } = useProgressContext();
  const { requestedCriteria, shouldUpdateSports } = useProfileCompletionContext();

  useEffect(() => {
    setTotal((current) => {
      return current + (requestedCriteria?.['hydra:member']?.length || 0)
        + (interaction.current_user_interaction_status.criterion_status.missing_mandatory.length ? 1 : 0)
        + (shouldUpdateSports ? 1 : 0);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SportsProvider sports={sports}>
      <ProfileCompletionIntroduction>
        <CriteriaCompletion
          contributor={contributor}
          interaction={interaction}
          refreshContributions={getContributions}
        >
          {children}
        </CriteriaCompletion>
      </ProfileCompletionIntroduction>
    </SportsProvider>
  );
};
